import { Button } from "@/components/ui/button";
import { ChecklistItem } from "@/features/onboarding/components/wizard";

export function WelcomeStep({ onStart }: { onStart: () => void }) {
  return (
    <div className="text-center py-4">
      <div className="mx-auto mb-5 w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="1.75" className="text-primary" strokeLinecap="round" strokeLinejoin="round"
          aria-hidden="true">
          <path d="M9 11l3 3L22 4" />
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
        </svg>
      </div>
      <h1 className="text-2xl font-semibold text-slate-900">Business Verification Required</h1>
      <p className="mt-2 text-sm text-slate-600 max-w-md mx-auto">
        To comply with banking and payment industry requirements, we need to verify and update
        your business information. Failure to complete this verification may result in delays or
        holds on your deposit funding.
      </p>
      <p className="mt-2 text-sm text-slate-600 max-w-md mx-auto">
        This process takes about 5 minutes.
      </p>

      <div className="mt-7 flex justify-center">
        <div className="text-left">
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3 text-center">
            Please verify
          </div>
          <ul className="space-y-3">
            <ChecklistItem icon="building">Business Information</ChecklistItem>
            <ChecklistItem icon="user">Owner Information</ChecklistItem>
            <ChecklistItem icon="card">Contact Information</ChecklistItem>
            <ChecklistItem icon="check">Deposit Bank Account</ChecklistItem>
          </ul>
        </div>
      </div>

      <Button type="button" size="lg" onClick={onStart} className="mt-7 w-full max-w-xs mx-auto gap-2">
        Start
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M5 12h14M13 5l7 7-7 7" />
        </svg>
      </Button>
    </div>
  );
}
